import gql from 'graphql-tag';
import { getGraphQLClientSpendControllerBaseline } from 'utils/apiRequests';

//Below two are helper functions for fieldname errors for graphql 2.4.0
function lowercaseFirstChar(obj) {
	const newObj = {};
	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			const value = obj[key];
			let newKey = key.charAt(0).toLowerCase() + key.slice(1);
			newKey = newKey === 'description' ? 'exploreDescription' : newKey;
			if (typeof value === 'object' && !Array.isArray(value)) {
				// Recursively lowercase first character of field names of nested objects
				newObj[newKey] = lowercaseFirstChar(value);
			} else {
				newObj[newKey] = value;
			}
		}
	}

	// Remove the "filterTo" and "dateTo" property if it exists
	delete newObj.filterTo;
	delete newObj.dateTo;

	return newObj;
}

const exploreLibraryQuery = (request, columns, data) => {
	const {
		cteModel,
		primaryTable,
		rowGroups,
		caseModel,
		valueCols,
		joinModel,
		havingModel,
		groupCols,
		filterModel,
	} = data;

	let fields = columns.map(col => col.field);
	const children = columns.reduce((acc, item) => {
		if (item.children && Array.isArray(item.children)) {
			return [...acc, ...item.children];
		}
		return acc;
	}, []);

	fields = fields.concat(children.map(col => col.field));
	return {
		query: gql`
			   query getSpendData(
    $cteExist: Boolean = null
    $startRow: Int!
    $endRow: Int!
    $primaryTable: String!
    $sorting: [SortModelType!] = null
    $rowGroups: [RowGroupModelType!] = null
    $valueCols: [ValueColsModelType!] = null
    $groupCols: [GroupColsModelType!] = null
    $joinModel: [JoinModelType!] = null
    $filterModel: [FilterModelType!] = null
    $havingModel: [HavingModelType!] = null
    $caseModel: [CaseModelType!] = null
			) {
				getSpendData(
					startRow: $startRow
					endRow: $endRow
					sorting: $sorting
					filterModel: $filterModel
                    cteExist:$cteExist
                    primaryTable:$primaryTable
                    rowGroups:$rowGroups
                    valueCols:$valueCols
                    groupCols:$groupCols
                    joinModel:$joinModel
                    havingModel:$havingModel
                    caseModel:$caseModel
				) {
					${[...fields, 'iD']}
				}
			}
		`,

		variables: {
			startRow: request.startRow || 0,
			endRow: request.endRow || 200,
			sortModel: request.sortModel,
			filterModel: [lowercaseFirstChar(...filterModel)],
			sorting: request.sortModel,
			cteModel,
			primaryTable,
			rowGroups,
			caseModel,
			valueCols,
			joinModel,
			havingModel,
			groupCols,
		},
	};
};

//this function makes columns from the data
const ServerSideDataSource = gridOptions => {
	return {
		// called by the grid when more rows are required
		getRows: async params => {
			const object = {};
			object.gridOptions = gridOptions;
			object.client = await getGraphQLClientSpendControllerBaseline();
			const columns = gridOptions.data.columnDefs;
			console.log(gridOptions);
			object.client
				.query(exploreLibraryQuery(params.request, columns, gridOptions.data))
				.then(response => {
					let rows = response.data.getSpendData;
					let lastRow = -1;
					if (rows.length <= 200) {
						lastRow = params.request.startRow + rows.length;
					}
					params.successCallback(rows, lastRow);
				})
				.catch(err => {
					console.error(err);
					params.failCallback();
				});
		},
	};
};

export default ServerSideDataSource;
